import { useEffect } from 'react';

export type UseLocalStorageChangeHandlerInput = {
  onLocalStorageChange: () => void;
};

/**
 * A hook that reacts on the local storage changes and calls the provided callback on such events.
 */
export default function useLocalStorageChangeHandler({ onLocalStorageChange }: UseLocalStorageChangeHandlerInput) {
  useEffect(() => {
    window.addEventListener('storage', onLocalStorageChange);

    return () => {
      window.removeEventListener('storage', onLocalStorageChange);
    };
  }, [onLocalStorageChange]);
}
